import type { ArrivalEntry } from '../../types';

export const arrivalData: ArrivalEntry[] = [
    {
        time: '2026-01-25',
        goods: [
            {
                name: '游园盲抽吧唧',
                count: 2,
            },
            {
                name: '艾莲文件夹',
                count: 1,
            }, 
            {
                name: '满赠闪卡 - 星见雅',
                count: 1,
            },
            {
                name: '满赠闪卡 - 仪玄',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 艾莲',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 莱特',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 2,
            },
        ]
    },
    {
        time: '2026-01-24',
        goods: [
            {
                name: '星见雅文件夹',
                count: 3,
            },
            {
                name: '艾莲文件夹',
                count: 1,
            },
            {
                name: '满赠闪卡 - 艾莲',
                count: 2,
            },
            {
                name: '满赠闪卡 - 橘福福',
                count: 1,
            },
            {
                name: '满赠闪卡 - 莱卡恩',
                count: 1,
            },
            {
                name: '满赠闪卡 - 耀嘉音',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 艾莲',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-19',
        goods: [
            {
                name: '满赠闪卡 - 耀嘉音',
                count: 1,
            },
            {
                name: '满赠闪卡 - 雨果',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-16',
        goods: [
            {
                name: '原神FES明信片',
                count: 1,
            },
            {
                name: '咩啊布',
                count: 1,
            },
            {
                name: '满赠闪卡 - 雨果',
                count: 1,
            },
            {
                name: '满赠闪卡 - 照',
                count: 1,
            },
            {
                name: '满赠闪卡 - 伊芙琳',
                count: 1,
            },
            {
                name: '满赠闪卡 - 月城柳',
                count: 1,
            },
            {
                name: '满赠闪卡 - 耀嘉音',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 安比',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 星见雅',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-15',
        goods: [
            {
                name: '原神FES明信片',
                count: 1,
            },
            {
                name: '原神FES贴纸',
                count: 1,
            },
            {
                name: '那维莱特色纸',
                count: 1,
            },
            {
                name: '星见雅镭射票',
                count: 1,
            },
            {
                name: '咩啊布',
                count: 2,
            },
            {
                name: '满赠闪卡 - 悠真',
                count: 2,
            },
            {
                name: '满赠闪卡 - 爱丽丝',
                count: 2,
            },
            {
                name: '满赠方卡 - 星见雅',
                count: 1,
            },
            {
                name: '满赠方卡 - 简',
                count: 1,
            },
            {
                name: '满赠方卡 - 莱卡恩',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-13',
        goods: [
            {
                name: '原神痛袋',
                count: 6,
            },
            {
                name: '原神糖果袋',
                count: 3,
            },
            {
                name: '原神饼干礼盒',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-12',
        goods: [
            {
                name: '原神胶片票根A',
                count: 2,
            },
            {
                name: '原神胶片票根B',
                count: 1,
            },
            {
                name: 'mini第一弹',
                count: 1,
            },
            {
                name: 'mini第四弹',
                count: 3,
            },
            {
                name: '游园盲抽吧唧',
                count: 5,
            },
            {
                name: '绳网盲抽吧唧',
                count: 14,
            },
            {
                name: '万年历（无壳）',
                count: 6,
            },
            {
                name: '万年历（带壳）',
                count: 2,
            },
            {
                name: '2.3 随单明信片',
                count: 23,
            },
            {
                name: '星见雅合影卡',
                count: 1,
            },
            {
                name: '艾莲合影卡',
                count: 1,
            },
            {
                name: '艾莲方吧唧',
                count: 1,
            },
            {
                name: '悠真亚克力',
                count: 1,
            },
            {
                name: '满赠闪卡 - 硫音',
                count: 1,
            },
            {
                name: '满赠闪卡 - 柚叶',
                count: 1,
            },
            {
                name: '满赠闪卡 - 星见雅',
                count: 2,
            },
            {
                name: '满赠闪卡 - 安比',
                count: 2,
            },
            {
                name: '满赠闪卡 - 月城柳',
                count: 1,
            },
            {
                name: '满赠闪卡 - 爱丽丝',
                count: 2,
            },
            {
                name: '满赠闪卡 - 莱卡恩',
                count: 2,
            },
            {
                name: '满赠闪卡 - 仪玄',
                count: 3,
            },
            {
                name: '满赠闪卡 - 悠真',
                count: 1,
            },
            {
                name: '满赠闪卡 - 简',
                count: 2,
            },
            {
                name: '满赠闪卡 - 橘福福',
                count: 2,
            },
            {
                name: '满赠闪卡 - 艾莲',
                count: 3,
            },
            {
                name: '满赠闪卡 - 雨果',
                count: 1,
            },
            {
                name: '满赠闪卡 - 照',
                count: 1,
            },
            {
                name: '满赠闪卡 - 伊芙琳',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 艾莲',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 悠真',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 简',
                count: 3,
            },
            {
                name: '满赠 mini 吧唧 - 星见雅',
                count: 2,
            },
            {
                name: '满赠 mini 吧唧 - 耀嘉音',
                count: 3,
            },
            {
                name: '满赠 mini 吧唧 - 安比',
                count: 2,
            },
            {
                name: '满赠 mini 吧唧 - 莱卡恩',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 莱特',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 2,
            },
            {
                name: '满赠方卡 - 安比',
                count: 1,
            },
            {
                name: '满赠方卡 - 简',
                count: 2,
            },
            {
                name: '满赠方卡 - 耀嘉音',
                count: 3,
            },
            {
                name: '满赠方卡 - 悠真',
                count: 3,
            },
        ]
    },
    {
        time: '2026-01-11',
        goods: [
            {
                name: '2.3 随单明信片',
                count: 3,
            },
            {
                name: '游园盲抽吧唧',
                count: 3,
            },
            {
                name: '绳网盲抽吧唧',
                count: 2,
            },
            {
                name: '万年历（无壳）',
                count: 11,
            },
            {
                name: '万年历（带壳）',
                count: 1,
            },
            {
                name: '满赠闪卡 - 赛斯',
                count: 1,
            },
            {
                name: '满赠闪卡 - 星见雅',
                count: 1,
            },
            {
                name: '满赠闪卡 - 月城柳',
                count: 1,
            },
            {
                name: '满赠闪卡 - 爱丽丝',
                count: 1,
            },
            {
                name: '满赠闪卡 - 莱卡恩',
                count: 1,
            },
            {
                name: '满赠闪卡 - 仪玄',
                count: 1,
            },
            {
                name: '满赠闪卡 - 悠真',
                count: 1,
            },
            {
                name: '满赠闪卡 - 简',
                count: 1,
            },
            {
                name: '满赠闪卡 - 橘福福',
                count: 1,
            },
            {
                name: '满赠闪卡 - 艾莲',
                count: 1,
            },
            {
                name: '满赠闪卡 - 雨果',
                count: 1,
            },
            {
                name: '满赠闪卡 - 照',
                count: 1,
            },
            {
                name: '满赠闪卡 - 伊芙琳',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 艾莲',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 悠真',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 简',
                count: 2,
            },
            {
                name: '满赠方卡 - 星见雅',
                count: 1,
            },
            {
                name: '满赠方卡 - 安比',
                count: 2,
            },
            {
                name: '满赠方卡 - 莱特',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
            {
                name: '满赠方卡 - 耀嘉音',
                count: 1,
            },
            {
                name: '满赠方卡 - 莱卡恩',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-10',
        goods: [
            {
                name: '星见雅方吧唧',
                count: 1,
            },
            {
                name: '星见雅立牌',
                count: 2,  
            },
            {
                name: '星见雅亚克力',
                count: 1,  
            },
            {
                name: '艾莲亚克力',
                count: 1,  
            },
            {
                name: '艾莲吧唧套组',
                count: 3,  
            },
            {
                name: '艾莲镭射票',
                count: 2,  
            },
            {
                name: '艾莲方吧唧',
                count: 3,  
            },
            {
                name: '安比方吧唧',
                count: 1,  
            },
            {
                name: '2.3 随单明信片',
                count: 4,
            },
            {
                name: '游园盲抽吧唧',
                count: 9,
            },
            {
                name: '绳网盲抽吧唧',
                count: 2,
            },
            {
                name: '满赠闪卡 - 硫音',
                count: 2,
            },
            {
                name: '满赠 mini 吧唧 - 安比',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 星见雅',
                count: 1,
            },
            {
                name: '满赠方卡 - 星见雅',
                count: 2,
            },
            {
                name: '满赠方卡 - 耀嘉音',
                count: 2,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-09',
        goods: [
            {
                name: '原神胶片票根B',
                count: 1,
            },
            {
                name: '星见雅方吧唧',
                count: 1,
            },
            {
                name: '悠真立牌',
                count: 1,  
            },
            {
                name: '2.3 随单明信片',
                count: 1,
            },
            {
                name: '游园盲抽吧唧',
                count: 1,
            },
            {
                name: '绳网盲抽吧唧',
                count: 2,
            },
            {
                name: '满赠闪卡 - 星见雅',
                count: 1,
            },
            {
                name: '满赠闪卡 - 简',
                count: 1,
            },
            {
                name: '满赠闪卡 - 爱丽丝',
                count: 1,
            },
            {
                name: '满赠闪卡 - 薇薇安',
                count: 1,
            },
            {
                name: '满赠闪卡 - 硫音',
                count: 1,
            },
            {
                name: '满赠闪卡 - 安比',
                count: 1,
            },
            {
                name: '满赠闪卡 - 柚叶',
                count: 1,
            },
            {
                name: '满赠闪卡 - 仪玄',
                count: 1,
            },
            {
                name: '满赠闪卡 - 莱特',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 安比',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 星见雅',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 简',
                count: 1,
            },
            {
                name: '满赠方卡 - 莱特',
                count: 1,
            },
            {
                name: '满赠方卡 - 耀嘉音',
                count: 1,
            },
            {
                name: '满赠方卡 - 艾莲',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-05',
        goods: [
            {
                name: 'mini第三弹',
                count: 1,
            },
            {
                name: 'mini第四弹',
                count: 2,
            },
            {
                name: 'mini柯蕾妲',
                count: 1,  
            },
            {
                name: 'mini格莉斯',
                count: 1,
            },
            {
                name: '2.3 随单明信片',
                count: 2,
            },
            {
                name: '满赠方卡 - 悠真',
                count: 2,
            },
            {
                name: '满赠方卡 - 莱卡恩',
                count: 1,
            },
        ]
    },
    {
        time: '2026-01-06',
        goods: [
            {
                name: '原神 FES 流沙摆件',
                count: 1,
            },
            {
                name: '满赠闪卡 - 星见雅',
                count: 2,
            },
            {
                name: '满赠闪卡 - 伊芙琳',
                count: 1,
            },
            {
                name: '满赠闪卡 - 悠真',
                count: 1,
            },
            {
                name: '满赠闪卡 - 莱特',
                count: 1,
            },
            {
                name: '满赠闪卡 - 叶瞬光',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 莱特',
                count: 1,
            },
            {
                name: '满赠 mini 吧唧 - 星见雅',
                count: 1,
            },
            {
                name: '满赠方卡 - 耀嘉音',
                count: 1,
            },
        ]
    }
];